import { render, staticRenderFns } from "./SamplePdfViewer.vue?vue&type=template&id=14edb599"
import script from "./SamplePdfViewer.vue?vue&type=script&lang=js"
export * from "./SamplePdfViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14edb599')) {
      api.createRecord('14edb599', component.options)
    } else {
      api.reload('14edb599', component.options)
    }
    module.hot.accept("./SamplePdfViewer.vue?vue&type=template&id=14edb599", function () {
      api.rerender('14edb599', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SamplePdfViewer.vue"
export default component.exports